import React, { useEffect, useState } from "react";
import { Modal, Typography, Tag, Divider, Row, Col, Space } from "antd";
import { TagsOutlined, UserOutlined } from "@ant-design/icons";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import useRequest from "../../hooks/useRequest";

const { Title, Text, Paragraph } = Typography;

const ORANGE = "#e2700d";

const ViewSkillTag = ({ open, onClose, skillId, refresh }) => {
  const { request } = useRequest();
  const [skillData, setSkillData] = useState({});

  const fetchSkill = (id) => {
    request({
      url: `${apiPath.listSkill}/${id}`,
      method: "GET",
      onSuccess: (res) => {
        setSkillData(res.data);
        refresh();
      },
    });
  };

  useEffect(() => {
    if (skillId) fetchSkill(skillId);
  }, [skillId, refresh]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      bodyStyle={{ background: "#fff", padding: 24 }}
      closeIcon={<span style={{ color: ORANGE, fontSize: 18 }}>×</span>}
    >
      {/* 🔹 HEADER */}
      <Row align="middle" gutter={16}>
        <Col>
          <TagsOutlined style={{ fontSize: 40, color: ORANGE }} />
        </Col>
        <Col flex="auto">
          <Title level={4} style={{ marginBottom: 0 }}>
            {skillData.name}
          </Title>
          <Text type="secondary">Skill Tag</Text>
        </Col>
        <Col>
          <Tag color={skillData.isActive ? "green" : "orange"}>
            {skillData.isActive ? "Active" : "Inactive"}
          </Tag>
        </Col>
      </Row>

      <Divider />

      {/* 🔹 DESCRIPTION */}
      {skillData.description && <Paragraph>{skillData.description}</Paragraph>}

      {/* 🔹 SUB TAGS */}
      {skillData.subTagsData && skillData.subTagsData.length > 0 && (
        <>
          <Divider orientation="left" style={{ color: ORANGE, margin: "12px 0" }}>
            Sub Tags
          </Divider>
          <Space wrap  >
            {skillData.subTagsData.map((subTagItem, idx) => (
              <div key={idx} style={{ marginBottom: "8px" }}>
                {subTagItem.subTagsName && (
                  <div style={{ marginBottom: "4px" }}>
                    <Text strong>{subTagItem.subTagsName}:</Text>
                  </div>
                )}
                <Space size={[0, 8]} wrap  >
                  {subTagItem.subTags && subTagItem.subTags.length > 0 ? (
                    subTagItem.subTags.map((tag, tagIdx) => (
                      <Tag color="orange" key={tagIdx}>
                        {tag}
                      </Tag>
                    ))
                  ) : (
                    <Text type="secondary">No sub tags</Text>
                  )}
                </Space>
              </div>
            ))}
          </Space>
        </>
      )}

      {/* 🔹 STATS */}
      <Row gutter={24} style={{ marginBottom: 16 }}>
        <Col>
          <Text>
            Usage Count: <b>{skillData.usageCount || 0}</b>
          </Text>
        </Col>
      </Row>

      {/* 🔹 META INFO */}
      <Divider orientation="left" style={{ color: ORANGE }}>
        Meta Information
      </Divider>

      <Space direction="vertical" size={6}>
        <Text>
          <UserOutlined /> Created By:{" "}
          <b>{skillData?.creatorDetails?.name || "-"}</b>
        </Text>
      </Space>

      {/* 🔹 DATES */}
      <Divider />
      <Text type="secondary" style={{ fontSize: 12 }}>
        Created:{" "}
        {skillData.createdAt
          ? moment(skillData.createdAt).format("DD MMM YYYY, hh:mm A")
          : "-"}
        <br />
        Updated:{" "}
        {skillData.updatedAt
          ? moment(skillData.updatedAt).format("DD MMM YYYY, hh:mm A")
          : "-"}
      </Text>
    </Modal>
  );
};

export default ViewSkillTag;
